module.exports = __webpack_public_path__ + "img/srdickaL.4fb0e602.png";